import React from "react"
import PropTypes, { string } from "prop-types"
import { browserHistory } from "react-router"
import Menu from "material-ui/Menu"
import MenuItem from "material-ui/MenuItem"
import strings from "../../localization/strings"
import AppStateStore from "../../stores/AppStateStore"
import AccountStore from "../../stores/AccountStore"
import { checkPositionFieldAvailable } from "../../helpers/positionHelper"

const propTypes = {
    navItems: PropTypes.array,
    selectedItem: PropTypes.string,
    accountId: PropTypes.string.isRequired
}

class AccountLeftNav extends React.Component {
    constructor() {
        super()
    }
    onClickHandler(item) {
        browserHistory.push("/account/" + this.props.accountId + "/" + item)
    }
    render() {
        const menuItems = this.props.navItems.map((item, index) => {
                        return (
                <MenuItem
                    data-intercom-target={`menu-Account-${strings[item].split(" ").join("-")}`}
                    primaryText={item === "Positions"  && checkPositionFieldAvailable('plural')  ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel : strings[item]}
                    style={{
                        color: this.props.selectedItem === item ? AppStateStore.getFrontEndSettings().UISettings.MenuSelectedTextColor : AppStateStore.getFrontEndSettings().UISettings.MenuIconColor
                    }}
                    value={strings[item]}
                    key={index}
                    onClick={this.onClickHandler.bind(this, item)}
                />
            )
        })

        return (
            <Menu
                style={{
                    backgroundColor: AppStateStore.getFrontEndSettings().UISettings.MenuSelectedBackgroundColor,
                    padding: 0,
                    height: 320
                }}
            >
                {menuItems}
            </Menu>
        )
    }
}

AccountLeftNav.propTypes = propTypes

export default AccountLeftNav
